<template>
  <ServicePageLayout
    title="Cold Water"
    subtitle="ระบบน้ำดี"
    icon="mdi-waves-arrow-up"
    icon-color="info"
    breadcrumb="Operations"
    :available="main_level.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>Dashboard</v-tab>
      <v-tab>History</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><Table /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="sanitary_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/sanitary/sanitary_dashboard'
import Table from '@/components/sanitary/sanitary_table'
import MACHINE_VIEW from '@/components/machine/machine_view'

export default {
  name: 'ColdWaterView',
  components: {
    ServicePageLayout,
    Dashboard,
    Table,
    MACHINE_VIEW
  },
  computed: {
    main_level() {
      return this.$store.state.Water.mainWaterLevel
    },
    sanitary_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === '20340ea6-88dd-11ee-b9d1-0242ac120004'
      )
    }
  },
  data() {
    return { tab: null }
  },
}
</script>
